import { useState } from 'react'

import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'

type PerencanaanReviewDiffProps = {
  originalLabel: string
  reviewLabel: string
  originalContent?: React.ReactNode
  reviewContent?: React.ReactNode
}

export function PerencanaanReviewDiff({
  originalLabel,
  reviewLabel,
  originalContent,
  reviewContent,
}: PerencanaanReviewDiffProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleOpen = () => {
    setIsOpen(true)
  }

  return (
    <>
      <div className="flex gap-3 items-center p-3 bg-surface-success-subdued rounded border border-green-50 max-w-sm">
        <Icon fontSize="sm" className="!text-xl !leading-5" color="success">
          check
        </Icon>
        <Text variant="subheading" className="uppercase whitespace-nowrap">
          Ada penyesuaian
        </Text>
        <Button
          size="sm"
          color="white"
          className="ml-auto"
          onClick={handleOpen}
        >
          Cek
        </Button>
      </div>

      <Dialog
        closeOnOverlayClick={false}
        size="lg"
        onClose={handleClose}
        isOpen={isOpen}
      >
        <DialogOverlay />
        <DialogContent>
          <div className="p-6 space-y-6">
            {originalContent && (
              <div className="space-y-2">
                <Text variant="heading-md" color="primary">
                  {originalLabel}
                </Text>
                {originalContent}
              </div>
            )}

            {originalContent && (
              <div className="mx-auto text-center">
                <Icon>arrow_downward</Icon>
              </div>
            )}

            {reviewContent && (
              <div className="space-y-2">
                <Text variant="heading-md" color="primary">
                  {reviewLabel}
                </Text>
                {reviewContent}
              </div>
            )}

            <Button onClick={handleClose} className="mx-auto">
              Saya mengerti
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
